"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var wcclassification_1 = tslib_1.__importDefault(require("./wcclassification"));
var employeetype_1 = tslib_1.__importDefault(require("./employeetype"));
var client_1 = tslib_1.__importDefault(require("./client"));
var project_1 = tslib_1.__importDefault(require("./project"));
var wccode_1 = tslib_1.__importDefault(require("./wccode"));
var OCCCodeResource = /** @class */ (function (_super) {
    tslib_1.__extends(OCCCodeResource, _super);
    function OCCCodeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OCCCodeResource.endpoint = '/occcodes';
    OCCCodeResource.MODEL_NAME = 'occcode';
    OCCCodeResource.related = {
        wc_classification: wcclassification_1.default,
        employee_type: employeetype_1.default,
        client: client_1.default,
        project: project_1.default,
        wc_code: wccode_1.default,
    };
    return OCCCodeResource;
}(base_1.default));
exports.default = OCCCodeResource;
//# sourceMappingURL=occcode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/occcode.js
// module id = uwKI
// module chunks = 0